
  var RELABEL={
    "Information du gérant":"Informations du parent",
    "Information du co-gérant":"Informations de l'enfant",
    "Profil de l'enregistrement":"Détails de la liste",
    "Info Livraison":"Informations de livraison",
    "Captcha Verification":"Vérification",
    "Accueil enregistrement":"Ma liste",
    "Open":"Ouverte",
    "Closed":"Clôturée",
    "Expired":"Expirée",
    "Quantity":"Quantité",
    "Acheter":"Articles achetés",
    "Please enter the text in the image below into the text box.":"Saisissez le texte affiché dans l'image ci-dessous.",
    "Can't see the image clearly? Click here to get a new one.":"Image illisible ? Cliquez ici pour en générer une autre.",
    "Send notification emails to registry managers (in addition to contact email)":"Recevoir les emails de notification (en plus de l'email de contact)",
    "Gérant":"Parent",
    "Co-gérant":"Enfant"
  };
  var peBon=null,peChild='';
  function inRegistryMode(){try{var r=localStorage.getItem('giftreggie-logged');if(!r)return false;var d=JSON.parse(r);return !!(d&&d.registry_id);}catch(e){return false;}}
  function relabel(){
    var front=document.querySelector('.giftreggie-front');if(!front)return;
    var w=document.createTreeWalker(front,NodeFilter.SHOW_TEXT,null);var n,changed=[];
    while(n=w.nextNode()){var t=n.textContent.trim();if(t&&RELABEL.hasOwnProperty(t)){changed.push([n,RELABEL[t]]);}}
    changed.forEach(function(p){p[0].textContent=p[1];});
    var sub=front.querySelector('.giftreggie-header > p');
    if(sub&&sub.textContent.trim()==='Description'){sub.textContent="Créez la liste d'envies de votre enfant. Vos proches lui offrent un cadeau, en ligne ou en boutique, sans aucun doublon.";}
    if(front.querySelector('.registry-profile')){document.body.classList.add('pe-gr-create');}
    var vr=front.querySelector('table.giftreggie-view-registry');
    var isOwner=!!front.querySelector('input[name^="want-quantity"]');
    if(vr&&!isOwner){document.body.classList.add('pe-gr-view');}
    if(isOwner){document.body.classList.add('pe-gr-manage');}
    if(front.querySelector('table.giftreggie-orders')){document.body.classList.add('pe-gr-orders');}
  }
  function updateGift(){
    if(!peBon)return;
    var t=document.querySelector('table.giftreggie-view-registry');if(!t)return;
    var total=0;
    [].slice.call(t.querySelectorAll('tr')).forEach(function(tr){
      var inp=tr.querySelector('input.registry-variant-quantity');if(!inp)return;
      var q=parseInt(inp.value,10)||0;if(q<=0)return;
      var c=tr.children;var pt=c[3]?(c[3].textContent||''):'';
      var price=parseFloat(pt.replace(/[^0-9,\.]/g,'').replace(',','.'))||0;
      total+=q*price;
    });
    if(total>0){var b=(total*0.10).toFixed(2).replace('.',',');peBon.style.display='block';peBon.innerHTML="🎁 Grâce à votre achat, le bon d'achat de <strong>"+peChild+"</strong> augmente de <strong>"+b+" €</strong> !";}
    else{peBon.style.display='none';}
  }
  function enhanceRegistryView(){
    var t=document.querySelector('table.giftreggie-view-registry');if(!t)return;
    if(t.querySelector('input[name^="want-quantity"]'))return;
    var form=document.querySelector('form.giftreggie-registry-form');
    var front=document.querySelector('.giftreggie-front');
    if(!t.getAttribute('data-pe-cols')){
      [].slice.call(t.querySelectorAll('tr')).forEach(function(tr,ri){
        var c=tr.children;if(c.length<8)return;
        if(ri===0){c[6].textContent='Disponibilité';c[4].style.display='none';c[5].style.display='none';}
        else{
          var s=(c[4].textContent||'').trim(),d=(c[5].textContent||'').trim(),b=(c[6].textContent||'').trim();
          c[4].style.display='none';c[5].style.display='none';
          var ai=tr.querySelector('input.registry-variant-quantity');if(ai){ai.setAttribute('data-max',b);}
          if(b===''||b==='0'){c[6].innerHTML='<span class="pe-gr-done">Déjà offert ✓</span>';}
          else{c[6].innerHTML='<span class="pe-gr-reste">Reste : '+b+'</span><br><span class="pe-gr-sub">'+s+' souhaité(s) · '+d+' déjà offert(s)</span>';}
        }
      });
      t.setAttribute('data-pe-cols','1');
    }
    [].forEach.call(t.querySelectorAll('input.registry-variant-quantity'),function(inp){
      if(inp.getAttribute('data-pe-step')==='1')return;inp.setAttribute('data-pe-step','1');
      var max=parseInt(inp.getAttribute('data-max'),10);if(isNaN(max))max=99;
      var minus=document.createElement('button');minus.type='button';minus.className='pe-gr-step';minus.textContent='−';
      var plus=document.createElement('button');plus.type='button';plus.className='pe-gr-step';plus.textContent='+';
      minus.addEventListener('click',function(){var v=(parseInt(inp.value,10)||0)-1;if(v<0)v=0;inp.value=v;updateGift();});
      plus.addEventListener('click',function(){var v=(parseInt(inp.value,10)||0)+1;if(v>max)v=max;inp.value=v;updateGift();});
      inp.parentNode.insertBefore(minus,inp);
      if(inp.nextSibling){inp.parentNode.insertBefore(plus,inp.nextSibling);}else{inp.parentNode.appendChild(plus);}
      inp.addEventListener('input',updateGift);
    });
    if(!form)return;
    if(!peChild){
      var regT=null;[].slice.call(front.querySelectorAll('table.giftreggie-desktop')).forEach(function(tb){if(!regT&&!tb.classList.contains('giftreggie-view-registry'))regT=tb;});
      if(regT){var drow=regT.querySelectorAll('tr')[1];if(drow&&drow.children[1]){var co=(drow.children[1].textContent||'').trim().replace(/^(m\.?|mr|mme|mlle|monsieur|madame|mademoiselle)\s+/i,'').trim();if(co&&!/^(aucun|none|n\/a|-)$/i.test(co))peChild=co.split(/\s+/)[0];}}
      if(!peChild){var desc=front.querySelector('.giftreggie-description');if(desc){var parts=desc.textContent.trim().split(/\sà\s/);peChild=parts[parts.length-1].trim();}}
      if(!peChild){var ti=front.querySelector('.giftreggie-registry-title');if(ti)peChild=ti.textContent.replace(/anniversaire/i,'').trim();}
      if(!peChild)peChild="l'enfant";
    }
    if(!peBon){peBon=document.createElement('div');peBon.className='pe-gr-bon';peBon.style.display='none';var ab=form.querySelector('.action-buttons');if(ab){ab.parentNode.insertBefore(peBon,ab);}else{form.appendChild(peBon);}}
    updateGift();
    var note=form.querySelector('textarea[name="note"]');
    if(note&&note.getAttribute('data-pe')!=='1'){
      note.setAttribute('data-pe','1');
      note.setAttribute('placeholder','Ex : joyeux anniversaire, plein de bisous');
      var lbl=null;var pp=note.parentNode;
      [].slice.call(pp.querySelectorAll('*')).forEach(function(el){if(!lbl&&el!==note&&el.children.length===0&&(el.textContent||'').trim()==='Note'){lbl=el;}});
      if(!lbl){var ps=note.previousElementSibling;if(ps&&(ps.textContent||'').trim()==='Note')lbl=ps;}
      if(lbl){lbl.textContent='Un petit mot pour intriguer (optionnel)';}
      var wrap=document.createElement('div');wrap.className='pe-gr-anon';
      wrap.innerHTML='<label><input type="checkbox" class="pe-gr-anon-cb"> Acheter en anonyme (mon prénom ne sera pas affiché sur la liste)</label>';
      note.parentNode.insertBefore(wrap,note);
      var cb=wrap.querySelector('.pe-gr-anon-cb');
      var coa=form.querySelector('.giftreggie-checkout');
      if(coa){coa.addEventListener('click',function(){if(cb.checked&&note.value.indexOf('(Cadeau anonyme)')===-1){note.value='(Cadeau anonyme) '+note.value;}});}
    }
    if(!form.getAttribute('data-pe-btns')){
      [].slice.call(form.querySelectorAll('button,input[type=submit]')).forEach(function(b){
        if(b.classList.contains('giftreggie-add-to-cart')||b.classList.contains('pe-gr-step'))return;
        var txt=(b.value||b.textContent||'').trim().toLowerCase();
        if(b.classList.contains('giftreggie-checkout')||/caisse|checkout|paiement/.test(txt)){if(b.tagName==='BUTTON'){b.textContent='Passer au paiement';}else{b.value='Passer au paiement';}}
        else if(/mettre|jour|update|actualis/.test(txt)){if(b.tagName==='BUTTON'){b.textContent='Mettre à jour mon panier';}else{b.value='Mettre à jour mon panier';}}
      });
      form.setAttribute('data-pe-btns','1');
    }
  }

/* ===== Mobile : bouton « Retirer de la liste » sur les cartes de la vue parent ===== */
(function(){
  function peAddMobileDeletes(){
    var front=document.querySelector('.giftreggie-front');if(!front)return;
    var form=front.querySelector('form.giftreggie-registry-form');if(!form)return;
    [].forEach.call(form.querySelectorAll('ul.giftreggie-mobile li'),function(li){
      if(li.getAttribute('data-pe-del')==='1')return;
      if(!li.querySelector('input[name^="want-quantity"]'))return;
      var idInp=li.querySelector('input[name="item-id"]');if(!idInp)return;
      var id=idInp.value;
      if(!form.querySelector('button[value="delete-'+id+'"]'))return;
      li.setAttribute('data-pe-del','1');
      var btn=document.createElement('button');
      btn.type='submit';btn.name='action';btn.value='delete-'+id;
      btn.className='pe-gr-remove';btn.textContent='Retirer de la liste';
      btn.addEventListener('click',function(e){
        if(!window.confirm('Retirer cet article de la liste ?')){e.preventDefault();}
      });
      li.appendChild(btn);
    });
  }
  function peInitDel(){peAddMobileDeletes();setInterval(peAddMobileDeletes,1200);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',peInitDel);}else{peInitDel();}
})();
